import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-data',
  templateUrl: './menu-data.component.html',
  styleUrls: ['./menu-data.component.css']
})
export class MenuDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
